import Cookies from 'js-cookie'
import { useLocation, useNavigate } from 'react-router-dom'

import { useEffect } from 'react'
import { Page } from '../../common/components'
import { useAppSelector } from '../../store'

const AuthRoute: React.FC = () => {
  const location = useLocation()
  const account = useAppSelector((state) => state.account)
  const navigate = useNavigate()

  const session = Cookies.get('session')
  const isAuthenticated = account?.login?.isLoggedIn && session

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/account/login', { state: { from: location } })
    }
  }, [isAuthenticated, navigate, location])

  if (!isAuthenticated) {
    return null
  }

  return <Page />
}

export default AuthRoute
